import { useEffect, useState } from "react";
import axios from "axios";
import { Mail, LayoutDashboard, Lock, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function StaffGate() {
  const [ok, setOk] = useState(() => sessionStorage.getItem("nx_staff_ok") === "1");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    document.title = "Staff Access — NexSecure";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await axios.post(`${API}/api/portal/staff-gate/verify`, { password: pw });
      sessionStorage.setItem("nx_staff_ok", "1");
      setOk(true);
    } catch {
      setErr("Incorrect access password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-nx-navy flex items-center justify-center px-6" data-testid="staff-gate-page">
      <div className="w-full max-w-sm text-center">
        <img src="/assets/logo-full-dark.svg" alt="NexSecure Technologies" className="w-52 mx-auto mb-8" />
        {!ok ? (
          <form onSubmit={submit} className="flex flex-col gap-4" data-testid="staff-gate-form">
            <p className="text-[10px] tracking-[0.28em] uppercase text-nx-goldlight">Staff Access</p>
            <div className="relative">
              <Lock size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
              <input
                type="password" autoFocus required placeholder="Access password" value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="w-full bg-white/[0.04] border border-white/15 text-slate-100 placeholder:text-slate-500 pl-11 pr-4 py-3.5 text-sm focus:outline-none focus:border-nx-goldlight/70 transition-colors"
                data-testid="staff-gate-password"
              />
            </div>
            {err && <p className="text-xs text-red-400" data-testid="staff-gate-error">{err}</p>}
            <button type="submit" disabled={busy}
              className="inline-flex items-center justify-center gap-2 bg-nx-gold hover:bg-nx-goldlight text-nx-navy font-semibold text-[11px] tracking-[0.2em] uppercase px-6 py-3.5 transition-colors disabled:opacity-60"
              data-testid="staff-gate-submit">
              {busy ? <Loader2 size={15} className="animate-spin" /> : "Enter"}
            </button>
          </form>
        ) : (
          <div className="flex flex-col gap-4" data-testid="staff-gate-links">
            <p className="text-[10px] tracking-[0.28em] uppercase text-nx-goldlight mb-2">Staff Tools</p>
            <a href="/webmail"
              className="flex items-center justify-center gap-3 border border-nx-gold/40 bg-nx-gold/[0.06] hover:bg-nx-gold/[0.12] text-white py-5 text-sm tracking-wide transition-colors"
              data-testid="staff-open-webmail">
              <Mail size={18} className="text-nx-goldlight" /> Open Webmail
            </a>
            <a href="/team-tracker"
              className="flex items-center justify-center gap-3 border border-white/15 bg-white/[0.03] hover:bg-white/[0.07] text-white py-5 text-sm tracking-wide transition-colors"
              data-testid="staff-open-tracker">
              <LayoutDashboard size={18} className="text-nx-goldlight" /> Open Team Tracker
            </a>
            <p className="text-xs text-slate-600 mt-4">NexSecure Technologies · Internal use only</p>
          </div>
        )}
      </div>
    </main>
  );
}
